// React
import { memo, useMemo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { TENANT_TABLE_COLUMNS } from "./consts";
import { TenantTableProps } from "./types";

/** Klijenti s njihovim stvarnim brojkama, najveći prvi. */
const TenantTable: React.FC<TenantTableProps> = (props: TenantTableProps) => {
  const { tenants, onOpenTenant } = props;

  /* `TableSearch` klik po retku javlja kroz `row.id`; naši redovi nose `tenantId`. */
  const rows = useMemo(
    () => tenants.map((tenant) => ({ ...tenant, id: tenant.tenantId })),
    [tenants]
  );

  return (
    <div className="bg-white border border-slate-200 p-4">
      <p className="text-base font-bold text-slate-600 mb-4">Klijenti</p>

      <TableSearch
        columns={TENANT_TABLE_COLUMNS}
        data={rows}
        selectableRows={false}
        disablePagination
        onRowClick={onOpenTenant}
      />
    </div>
  );
};

export default memo(TenantTable);
